<template>
  <card :class="['card-stats', variantClass]" :show-footer-line="true">
    <div class="row">
      <div class="col">
        <slot>
          <h5 class="card-title text-uppercase mb-0" v-if="title">{{ title }}</h5>
          <span class="h2 font-weight-bold mb-0" v-if="subTitle">{{ subTitle }} pts</span>
          <span class="h2 font-weight-bold mb-0" v-if="minTitle">{{ minTitle }}</span>
        </slot>
      </div>

      <div class="col-auto" v-if="$slots.icon || icon">
        <slot name="icon">
          <div class="icon icon-shape rounded-circle shadow"
               :class="iconClasses"
               style="background-color: transparent; border: 2px solid #F15A22; color: #F15A22; width: 50px; height: 50px;">
            <i :class="icon"></i>
          </div>
        </slot>
      </div>
    </div>

    <p class="mb-0 text-sm">
      <slot name="footer"></slot>
    </p>
  </card>
</template>

<script>
import Card from './Card.vue';

export default {
  name: 'stats-card',
  components: {
    Card
  },
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    icon: String,
    title: String,
    subTitle: String,
    minTitle: String,
    iconClasses: [String, Array],
    variant: {
      type: String,
      default: 'white',
      validator: val => ['white', 'blue'].includes(val)
    }
  },
  computed: {
    variantClass() {
      return this.variant === 'blue' ? 'blue-bg' : 'white-bg';
    }
  }
};
</script>
<style scoped>
.card-stats {
  border-radius: 0.5rem;
  padding: 1rem;
  max-height: 110px;
}

.card-title {
  font-weight: 900;
}

.white-bg {
  background-color: #ffffff;
}

.blue-bg {
  background-color: #003A90;
  color: white;
}

.white-bg .card-title,
.white-bg .h2 {
  color: #003A90 !important;
}

.blue-bg .card-title,
.blue-bg .h2 {
  color: #ffffff !important;
}

</style>

